import { DecimalSchema } from "../decimal";
import { UneligibleTradeReason } from "../shared/campaign-types";
import { z } from "zod";

export const CurrentUserVolumeInWindowSchema = z.object({
  currentWindowVolume: DecimalSchema,
  nextWindowDate: z.coerce.date().optional(),
});
export type CurrentUserVolumeInWindow = z.infer<typeof CurrentUserVolumeInWindowSchema>;

export const CurrentUserVolumeInPhaseSchema = z.object({
  userVolume: DecimalSchema,
});
export type CurrentUserVolumeInPhase = z.infer<typeof CurrentUserVolumeInPhaseSchema>;

export const ShouldDisableTradeSchema = z.object({
  shouldDisableTrade: z.union([z.boolean(), z.enum(UneligibleTradeReason)]),
});
export type ShouldDisableTradeDto = z.infer<typeof ShouldDisableTradeSchema>;
